module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('md-list', [_c('md-subheader', [_vm._v(_vm._s(_vm.title) + " - " + _vm._s(_vm.competitors.length))]), _vm._v(" "), _vm._l((_vm.competitors), function(competitor) {
    return _c('md-list-item', {
      key: competitor.id
    }, [_c('Competitor', {
      attrs: {
        "tournament": _vm.tournament,
        "competitor": competitor
      }
    })], 1)
  })], 2), _vm._v(" "), _c('p')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a582d82","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tournamentComponents/competitorList.vue
// module id = 447
// module chunks = 1